module.exports = __webpack_public_path__ + "img/cn6.14830e0.png";